import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import * as api from '../../../api/educentialApi';
import CareerDashboard from './CareerDashboard';
import CareerAssessment from './CareerAssessment';
import SessionBooking from './SessionBooking';
import CareerPlan from './CareerPlan';
import CareerGoals from './CareerGoals';

const CareerServiceRoutes = () => {
  const [loading, setLoading] = useState(true);
  const [enrolled, setEnrolled] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    checkEnrollment();
  }, []);

  const checkEnrollment = async () => {
    try {
      setLoading(true);
      const response = await api.getServiceStatus('career');
      
      if (response.data.enrolled) {
        setEnrolled(true);
      } else {
        await api.enrollInService('career');
        setEnrolled(true);
      }
    } catch (err) {
      console.error('Error checking enrollment:', err);
      setError('Failed to access service');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading Career Counseling service...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <p className="text-red-800 mb-4">{error}</p>
          <button
            onClick={() => navigate('/services')}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Back to Services
          </button>
        </div>
      </div>
    );
  }

  if (!enrolled) {
    return <Navigate to="/services" replace />;
  }

  return (
    <Routes>
      <Route index element={<CareerDashboard />} />
      <Route path="assessment" element={<CareerAssessment />} />
      <Route path="sessions" element={<SessionBooking />} />
      <Route path="plan" element={<CareerPlan />} />
      <Route path="goals" element={<CareerGoals />} />
      <Route path="*" element={<Navigate to="/services/career" replace />} />
    </Routes>
  );
};

export default CareerServiceRoutes;
